import type { SiteName } from '@/scopes/common/domain/types'
import { AmountType, AmountTypeValues, PaymentAmount, PaymentScopePage } from '@/scopes/payment/domain/types'

interface PageAmountsOrder {
  default: AmountType[]
  siteOverrides?: Partial<Record<SiteName, AmountType[]>>
}

type PaymentAmountsOrderConfig = Partial<Record<PaymentScopePage, PageAmountsOrder>>

const FULL_FIRST: AmountType[] = [AmountTypeValues.FULL, AmountTypeValues.DEPOSIT]
const DEPOSIT_FIRST: AmountType[] = [AmountTypeValues.DEPOSIT, AmountTypeValues.FULL]
const MIN_DEPOSIT_FIRST: AmountType[] = [AmountTypeValues.MIN_DEPOSIT, AmountTypeValues.DEPOSIT, AmountTypeValues.FULL]

const PAYMENT_AMOUNTS_ORDER: PaymentAmountsOrderConfig = {
  BookingPayment: {
    default: FULL_FIRST,
  },
  MandatoryPayment: {
    default: DEPOSIT_FIRST,
    siteOverrides: {
      sunwebnl: MIN_DEPOSIT_FIRST,
      sunwebbenl: MIN_DEPOSIT_FIRST,
      sunwebbefr: MIN_DEPOSIT_FIRST,
    },
  },
}

export function getPaymentAmountsSorter(
  siteName: SiteName,
  page: PaymentScopePage = 'Payment',
): (paymentAmounts: PaymentAmount[]) => PaymentAmount[] {
  if (!siteName) {
    return paymentAmounts => paymentAmounts
  }

  const pageOrder = PAYMENT_AMOUNTS_ORDER[page]
  const order = pageOrder?.siteOverrides?.[siteName] ?? pageOrder?.default

  if (!order) {
    return paymentAmounts => paymentAmounts
  }

  return (paymentAmounts) => {
    const sorted: PaymentAmount[] = []
    const remaining = [...paymentAmounts]
    for (const type of order) {
      const index = remaining.findIndex(amount => amount.type.toLowerCase() === type.toLowerCase())
      if (index !== -1) {
        sorted.push(remaining.splice(index, 1)[0])
      }
    }

    return [...sorted, ...remaining]
  }
}
